var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3404 18.97C24.3751 16.266 25.8228 13.7074 28.1194 12.2911C26.6706 10.2156 24.2439 8.89962 21.7192 8.82038C19.0263 8.53686 16.4157 10.4367 15.0435 10.4367C13.6447 10.4367 11.532 8.84853 9.25688 8.89549C6.2914 8.99159 3.52683 10.6828 2.08407 13.2834C-1.01731 18.6696 1.29604 26.5854 4.2669 30.9391C5.75328 33.071 7.49044 35.4524 9.76347 35.3679C11.9878 35.2754 12.8185 33.9452 15.5034 33.9452C18.1634 33.9452 18.9428 35.3679 21.262 35.3142C23.6488 35.2754 25.1525 33.1729 26.5868 31.0208C27.6547 29.5017 28.4765 27.8228 29.0217 26.0463C26.2168 24.8563 24.3437 22.0248 24.3404 18.97Z",
    fill: "#090909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9599 5.95715C21.2613 4.39008 21.9024 2.37588 21.7471 0.342285C19.7589 0.551752 17.9224 1.50492 16.6034 3.01186C15.3137 4.48423 14.6425 6.46299 14.7694 8.41886C16.7583 8.4394 18.7136 7.51207 19.9599 5.95715Z",
    fill: "#090909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkAppleLogo);
export default __webpack_public_path__ + "static/media/dark-apple-logo.2e6606efa1bf63e17cbafda2ce9e9091.svg";
export { ForwardRef as ReactComponent };